import { render, staticRenderFns } from "./safemanage.vue?vue&type=template&id=5dbfcc15&scoped=true&"
import script from "./safemanage.vue?vue&type=script&lang=js&"
export * from "./safemanage.vue?vue&type=script&lang=js&"
import style0 from "./safemanage.vue?vue&type=style&index=0&id=5dbfcc15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbfcc15",
  null
  
)

export default component.exports